import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { leaveRequestEditTourSteps } from "./leaveRequestEditTourSteps";
import { useLeaveTour } from "./useLeaveTour";

const TOUR_STORAGE_KEY = "hr-leave-request-edit-tour-completed";

type LeaveRequestEditTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
  }) => void;
};

export function LeaveRequestEditTour({
  run,
  onCallback,
}: LeaveRequestEditTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={leaveRequestEditTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useLeaveRequestEditTour() {
  return useLeaveTour(TOUR_STORAGE_KEY);
}
